"use client";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useRef, useState } from "react";
import classNames from "classnames";
import { SelectorDropDown, } from "@travel/shared/ui";
import { useLocation } from "@travel/shared/locations/data-access";
import { useLocationSearch } from "@travel/shared/locations/data-access";
import AirplaneIcon from "@travel/shared/assets/icons/icon-airplane.svg";
import CityIcon from "@travel/shared/assets/icons/icon-city.svg";
import HotelIcon from "@travel/shared/assets/icons/icon-hotel.svg";
import LocationIcon from "@travel/shared/assets/icons/icon-location.svg";
import GPSIcon from "@travel/shared/assets/icons/icon-gps.svg";
import styles from "./location-search-feature.module.css";
var CATEGORIES = {
    geo: {
        icon: _jsx(GPSIcon, {}),
    },
    city: {
        title: "Cities",
        icon: _jsx(CityIcon, {}),
    },
    airport: {
        title: "Airports",
        icon: _jsx(AirplaneIcon, {}),
    },
    nearby: {
        title: "Nearby Cities",
        icon: _jsx(HotelIcon, {}),
    },
    hotel: {
        title: "Hotel",
        icon: _jsx(HotelIcon, {}),
    },
    poi: {
        title: "Points of interest",
        icon: _jsx(LocationIcon, {}),
    },
    recent: {
        title: "Recent searches",
    },
};
var LOCATION_PRIORITY = [
    "geo",
    "recent",
    "city",
    "airport",
    "nearby",
    "hotel",
];
var GEOLOCATION_OPTION = {
    id: 5,
    type: "geo",
    category: "geo",
    displayName: "Around current location",
};
export function LocationSearchFeature(props) {
    var _a, _b;
    var _c = props.recent, recent = _c === void 0 ? [] : _c, _d = props.hideArrow, hideArrow = _d === void 0 ? true : _d;
    var _e = __read(useState(((_a = props.selected) === null || _a === void 0 ? void 0 : _a.displayName) || ""), 2), query = _e[0], setQuery = _e[1];
    var nameFromFoundLocation = useRef(((_b = props.selected) === null || _b === void 0 ? void 0 : _b.displayName) || "");
    var _f = __read(useState(props.selected), 2), selected = _f[0], setSelected = _f[1];
    var _g = __read(useState(props.focused), 2), isFocused = _g[0], setIsFocused = _g[1];
    var initialSelectedRef = useRef(selected);
    var _h = useLocation(props.locationType, props.locationID), foundLocation = _h.data, isLoadingLocation = _h.isLoading;
    var _j = useLocationSearch(isLoadingLocation
        ? null
        : nameFromFoundLocation.current === query
            ? null
            : query), data = _j.data, isLoading = _j.isLoading;
    var _k = __read(useState(data), 2), lastData = _k[0], setLastData = _k[1];
    var list = useMemo(function () {
        var _a;
        return (query.length < 3
            ? __spreadArray([GEOLOCATION_OPTION], __read(recent), false) : (data && ((_a = data === null || data === void 0 ? void 0 : data.list) === null || _a === void 0 ? void 0 : _a.length)
            ? data.list
            : (lastData === null || lastData === void 0 ? void 0 : lastData.list) || __spreadArray([GEOLOCATION_OPTION], __read(recent), false)) || [
            GEOLOCATION_OPTION,
        ]).map(function (location) { return (__assign(__assign({}, location), { category: location.category || location.type })); });
    }, [query, data, lastData, recent]);
    var selectedValue = useMemo(function () {
        var _a;
        return selected
            ? (_a = {},
                _a[selected.id] = true,
                _a) : {};
    }, [selected]);
    useEffect(function () {
        var _a;
        if (data && ((_a = data === null || data === void 0 ? void 0 : data.list) === null || _a === void 0 ? void 0 : _a.length)) {
            setLastData(data);
        }
    }, [data]);
    useEffect(function () {
        initialSelectedRef.current = selected;
    }, [isFocused]);
    useEffect(function () {
        setIsFocused(props.focused);
    }, [props.focused]);
    useEffect(function () {
        setSelected(props.selected);
    }, [props.selected]);
    useEffect(function () {
        var _a;
        if (foundLocation) {
            nameFromFoundLocation.current = foundLocation.displayName || "";
            setQuery(foundLocation.displayName || "");
            setSelected(foundLocation);
            (_a = props.onSelect) === null || _a === void 0 ? void 0 : _a.call(props, foundLocation);
        }
    }, [foundLocation]);
    return (_jsx(SelectorDropDown, __assign({}, props, { value: isLoadingLocation
            ? "Searching..."
            : sanitizeQuery(query || (selected === null || selected === void 0 ? void 0 : selected.displayName) || ""), classNames: {
            item: styles["location-item"],
        }, clear: true, selected: selectedValue, list: list, focused: isFocused, disabled: isLoadingLocation || props.disabled, groupPriorities: LOCATION_PRIORITY, canShowPanel: list.length > 0, hideArrow: hideArrow, 
        //icon={<SearchIcon width={22} height={22} />}
        loadingLabel: "Loading location...", hideFooterDesktop: true, renderTitle: function (category) {
            var _a;
            return category !== "geo" && (_jsx("div", { className: styles["title"], children: (_a = CATEGORIES[category]) === null || _a === void 0 ? void 0 : _a.title }));
        }, renderItem: function (location, isSelected, isFocused) { return (_jsx(LocationSearchItem, { location: location, selected: isSelected, focused: isFocused })); }, onChange: handleInputChange, onSelect: handleSelect, onFocusChange: function (isFocused) {
            var _a;
            setIsFocused(isFocused);
            (_a = props.onFocusChange) === null || _a === void 0 ? void 0 : _a.call(props, isFocused);
        }, onClickClose: handleClickClose })));
    function handleSelect(item) {
        var _a, _b;
        if (item) {
            setIsFocused(false);
            (_a = props.onSelect) === null || _a === void 0 ? void 0 : _a.call(props, item);
        }
        else {
            (_b = props.onSelect) === null || _b === void 0 ? void 0 : _b.call(props, item);
        }
    }
    function handleInputChange(data) {
        var _a, _b;
        if (data === null || data === void 0 ? void 0 : data.currentTarget) {
            var value = (_a = data === null || data === void 0 ? void 0 : data.currentTarget) === null || _a === void 0 ? void 0 : _a.value;
            if (!nameFromFoundLocation.current ||
                (nameFromFoundLocation.current &&
                    nameFromFoundLocation.current !== value)) {
                nameFromFoundLocation.current = "";
                setQuery(value);
            }
            if (!value) {
                setQuery("");
                setSelected(undefined);
                (_b = props.onSelect) === null || _b === void 0 ? void 0 : _b.call(props);
            }
        }
    }
    function handleClickClose() {
        var _a, _b;
        setSelected(initialSelectedRef.current);
        setQuery(((_a = initialSelectedRef.current) === null || _a === void 0 ? void 0 : _a.name) || "");
        (_b = props.onClickClose) === null || _b === void 0 ? void 0 : _b.call(props);
    }
}
function LocationSearchItem(_a) {
    var _b;
    var _c;
    var location = _a.location, selected = _a.selected, focused = _a.focused;
    return (_jsxs("div", { className: classNames(styles["item"], (_b = {},
            _b[styles["is-focused"]] = focused || selected,
            _b)), children: [_jsx("span", { className: styles["icon"], children: location.type ? (_c = CATEGORIES[location.type]) === null || _c === void 0 ? void 0 : _c.icon : null }), _jsx("span", { dangerouslySetInnerHTML: { __html: location.displayName || "" } })] }));
}
//@TODO: Look into a more robust solution
function sanitizeQuery(query) {
    return query.replace("&amp;", "&");
}
